/* Lost in Swiss · rediseño 2026 · comportamiento compartido */
(function () {
  document.documentElement.classList.add('js');

  // Desplazamiento: en móvil el que se desplaza es <body> (lis.css), no la página. Así Safari de iPhone
  // no puede dibujar el contenido que pasa por debajo de la barra de estado por encima de la cabecera fija.
  var lisScroll = window.lisScroll = {
    el: function () { return getComputedStyle(document.body).overflowY === 'auto' ? document.body : null; },
    y: function () { var e = this.el(); return e ? e.scrollTop : (window.scrollY || window.pageYOffset || 0); },
    x: function () { var e = this.el(); return e ? e.scrollLeft : (window.scrollX || 0); },
    to: function (top, behavior) { var o = { top: top, left: 0, behavior: behavior || 'auto' }; var e = this.el(); if (e) e.scrollTo(o); else window.scrollTo(o); },
    on: function (fn) { window.addEventListener('scroll', fn, { passive: true }); document.body.addEventListener('scroll', fn, { passive: true }); },
    off: function (fn) { window.removeEventListener('scroll', fn); document.body.removeEventListener('scroll', fn); }
  };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Entrada suave de los bloques al hacer scroll. El umbral es 0 (basta con que asome un
  // píxel): con el 5 % de antes, un bloque de varias pantallas (la lista de la checklist,
  // 38 puntos) no llegaba nunca a ese 5 % y se quedaba en blanco hasta bajar muy adentro.
  var els = document.querySelectorAll('.lis .reveal'), io = null;
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('visto'); });
  } else {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('visto'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
  }
  // Para bloques .reveal que se pintan después (las opiniones de la encuesta en la portada):
  // se apuntan al mismo observador, o se dan por vistos si no hay animación.
  window.lisReveal = function (raiz) {
    (raiz || document).querySelectorAll('.reveal:not(.visto)').forEach(function (e) { if (io) io.observe(e); else e.classList.add('visto'); });
  };

  // Desplegable "Mi área": se cierra al pulsar fuera o con Escape
  document.querySelectorAll('.lis-header details.menu').forEach(function (m) {
    document.addEventListener('click', function (e) { if (m.open && !m.contains(e.target)) m.open = false; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') m.open = false; });
  });

  // Fichas de las herramientas: guardamos la posición de la página al abrir y la restauramos al cerrar
  // (Safari en iPhone salta arriba del todo si no se hace). No se bloquea el scroll del fondo: en iOS eso también provoca el salto.
  var posicion = 0, origen = null;
  document.querySelectorAll('[data-ficha]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var d = document.getElementById(b.getAttribute('data-ficha'));
      if (!d || !d.showModal) return;
      posicion = lisScroll.y(); origen = b;
      d.showModal();
      lisScroll.to(posicion, 'instant');
      requestAnimationFrame(function () { lisScroll.to(posicion, 'instant'); });
    });
  });
  document.querySelectorAll('dialog.ficha').forEach(function (d) {
    d.addEventListener('close', function () {
      lisScroll.to(posicion, 'instant');
      setTimeout(function () { lisScroll.to(posicion, 'instant'); }, 0);
      if (origen) origen.focus({ preventScroll: true });
    });
    var c = d.querySelector('.cerrar'); if (c) c.addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.querySelectorAll('a[href^="#"]').forEach(function (a) { a.addEventListener('click', function () { d.close(); }); });
  });

  // Portada: si el navegador ya pasó de la fecha de la subida (la página puede venir de caché), se esconde el aviso
  document.querySelectorAll('[data-limite]').forEach(function (el) {
    var lim = new Date(el.getAttribute('data-limite') + 'T00:00:00');
    if (isNaN(lim) || Date.now() < lim.getTime()) return;
    el.querySelectorAll('.solo-antes').forEach(function (e) { e.remove(); });
    if (el.classList.contains('solo-antes')) el.remove();
  });

  // Preguntas frecuentes: los enlaces que apuntan a UNA pregunta (#pregunta-xxx) la abren y la dejan
  // justo debajo de la cabecera fija. El salto normal del navegador no sirve: la pregunta está cerrada
  // y en móvil quien se desplaza es <body>, no la página.
  var irAPregunta = function (hash, suave) {
    if (!hash || hash.indexOf('#pregunta-') !== 0) return false;
    var d = document.getElementById(hash.slice(1));
    if (!d || d.tagName !== 'DETAILS') return false;
    d.open = true;
    // El bloque de preguntas puede no haber "aparecido" todavía (animación .reveal, que lo baja 22px).
    // Se le da por visto sin animación ANTES de medir; si no, la pregunta acaba debajo de la cabecera.
    for (var n = d; n && n.classList; n = n.parentElement) {
      if (!n.classList.contains('reveal') || n.classList.contains('visto')) continue;
      var trans = n.style.transition;
      n.style.transition = 'none';
      n.classList.add('visto');
      void n.offsetHeight;
      n.style.transition = trans;
    }
    var tapa = window.innerWidth <= 900 ? 96 : 118;
    requestAnimationFrame(function () {
      var y = lisScroll.y() + d.getBoundingClientRect().top - tapa;
      lisScroll.to(y < 0 ? 0 : y, suave && !reduce ? 'smooth' : 'auto');
    });
    return true;
  };
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="#pregunta-"]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var hash = href.slice(href.indexOf('#'));
    if (irAPregunta(hash, true)) {
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', hash);
    }
  });
  window.addEventListener('hashchange', function () { irAPregunta(location.hash, true); });
  if (location.hash.indexOf('#pregunta-') === 0) setTimeout(function () { irAPregunta(location.hash, false); }, 60);

  // Portada: barra de compra fija en móvil. Aparece al pasar la portada y se esconde en el precio, en el cierre,
  // en el pie y mientras hay una ficha abierta. Va por scroll (no por IntersectionObserver) para que funcione en todos los navegadores.
  var barra = document.querySelector('.lis-barra-compra'), heroBarra = document.querySelector('.lis-hero');
  if (barra && heroBarra) {
    barra.hidden = false;
    var ocultan = [].slice.call(document.querySelectorAll('.lis-precio, .lis-cierre, .lis-footer'));
    var pendiente = false;
    var pintaBarra = function () {
      pendiente = false;
      var vh = window.innerHeight;
      var pasado = heroBarra.getBoundingClientRect().bottom < 0;
      var tapa = ocultan.some(function (s) { var r = s.getBoundingClientRect(); return r.top < vh * .85 && r.bottom > vh * .15; });
      var fichaAbierta = !!document.querySelector('dialog.ficha[open]');
      barra.classList.toggle('visible', pasado && !tapa && !fichaAbierta);
    };
    var pideBarra = function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintaBarra); } };
    lisScroll.on(pideBarra); window.addEventListener('resize', pideBarra);
    document.querySelectorAll('dialog.ficha').forEach(function (d) { d.addEventListener('close', pideBarra); });
    document.querySelectorAll('[data-ficha]').forEach(function (b) { b.addEventListener('click', function () { setTimeout(pideBarra, 50); }); });
    pideBarra();
  }

  // Candidaturas: la tarjeta de "elige empresas" se reparte en dos columnas
  // (filtros a la izquierda, lista de empresas a la derecha). Solo se mueven nodos; la lógica no cambia.
  var cont = document.querySelector('[class^="cand-container-"]');
  if (cont) {
    var cards = [].slice.call(cont.querySelectorAll(':scope > [class^="cand-card-"]'));
    if (cards.length >= 2) {
      var rej = document.createElement('div'); rej.className = 'lis-cand-rejilla';
      var izq = document.createElement('div'); izq.className = 'lis-cand-izq';
      var der = document.createElement('div'); der.className = 'lis-cand-der';
      cards[1].parentNode.insertBefore(rej, cards[0]);
      rej.appendChild(izq); rej.appendChild(der);
      izq.appendChild(cards[0]); izq.appendChild(cards[1]);
      var vacio = document.createElement('div'); vacio.className = 'lis-cand-vacio'; vacio.innerHTML = '<b>Aquí saldrán las empresas</b>Rellena tu perfil, ajusta los filtros y pulsa "Buscar empresas". Al tocar una, verás el email listo para abrir en tu correo.';
      der.appendChild(vacio);
      var aLaDerecha = ['[class^="cand-toolbar-"]', '[class^="cand-company-list-"]', '[id^="cand-load-more-"]', '[class^="cand-sentbox-"]', '[class^="cand-faq-"]'];
      aLaDerecha.forEach(function (sel) { var n = cards[1].querySelector(sel); if (n) der.appendChild(n); });
      var lista = der.querySelector('[class^="cand-company-list-"]');
      if (lista) { var ver = function () { vacio.style.display = lista.children.length ? 'none' : ''; }; new MutationObserver(ver).observe(lista, { childList: true }); ver(); }
      if (der.children.length < 2) { rej.parentNode.insertBefore(cards[0], rej); rej.parentNode.insertBefore(cards[1], rej); rej.remove(); }
      // Al marcar una empresa como enviada, a los pocos segundos desaparece de la lista (sigue en "Mis candidaturas")
      if (lista) new MutationObserver(function (ms) {
        ms.forEach(function (m) {
          if (m.type !== 'attributes' || m.attributeName !== 'class') return;
          var card = m.target; if (!card.classList.contains('is-sent') || card.getAttribute('data-lis-timer')) return;
          card.setAttribute('data-lis-timer', '1');
          setTimeout(function () {
            if (!card.classList.contains('is-sent')) { card.removeAttribute('data-lis-timer'); return; }
            card.style.transition = 'opacity .5s, max-height .5s'; card.style.overflow = 'hidden'; card.style.maxHeight = card.offsetHeight + 'px';
            requestAnimationFrame(function () { card.style.opacity = '0'; card.style.maxHeight = '0'; });
            setTimeout(function () { card.remove(); ver(); }, 550);
          }, 4000);
        });
      }).observe(lista, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
  }

  // Portada: motas de luz cálida flotando (se pausa fuera de pantalla y con "reducir movimiento")
  var hero = document.querySelector('.lis-hero'), cv = hero && hero.querySelector('canvas.luz');
  if (cv && !reduce) {
    var ctx = cv.getContext('2d'), motas = [], W = 0, H = 0, activo = true, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var medir = function () {
      W = hero.clientWidth; H = hero.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.min(70, Math.round(W * H / 22000)); motas = [];
      for (var i = 0; i < n; i++) motas.push(nueva(true));
    };
    var nueva = function (inicial) {
      return { x: Math.random() * W, y: inicial ? Math.random() * H : H + 10, r: .8 + Math.random() * 2.2, a: .12 + Math.random() * .38,
               v: .08 + Math.random() * .22, f: Math.random() * Math.PI * 2, s: .15 + Math.random() * .35, t: Math.random() * 1000 };
    };
    var pinta = function () {
      if (!activo) return;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < motas.length; i++) {
        var m = motas[i]; m.t += 1; m.y -= m.v; m.x += Math.sin(m.t / 60 + m.f) * m.s * .3;
        var brillo = m.a * (0.6 + 0.4 * Math.sin(m.t / 45 + m.f));
        var g = ctx.createRadialGradient(m.x, m.y, 0, m.x, m.y, m.r * 3);
        g.addColorStop(0, 'rgba(255,241,214,' + brillo + ')'); g.addColorStop(1, 'rgba(255,241,214,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(m.x, m.y, m.r * 3, 0, Math.PI * 2); ctx.fill();
        if (m.y < -12) motas[i] = nueva(false);
      }
      requestAnimationFrame(pinta);
    };
    medir(); window.addEventListener('resize', medir);
    new IntersectionObserver(function (en) { var v = en[0].isIntersecting; if (v && !activo) { activo = true; pinta(); } else if (!v) activo = false; }).observe(hero);
    pinta();
  }
})();

// Guía rápida de primera visita en las herramientas (CV y candidaturas).
// Cada página define sus pasos en <script type="application/json" class="lis-tour" data-clave="...">.
// Se muestra una sola vez por navegador (localStorage) y se puede repetir con [data-tour-ver].
(function () {
  var def = document.querySelector('script.lis-tour');
  function iniciar(clave, pasos) {
    pasos = pasos.filter(function (p) { var el = document.querySelector(p.sel); return el && el.getBoundingClientRect().height > 0; });
    if (!pasos.length || document.querySelector('.lis-tour-anillo')) return;
    var i = 0, objetivo = null, movil = function () { return window.innerWidth <= 700; };
    var anillo = document.createElement('div'); anillo.className = 'lis-tour-anillo';
    var tarjeta = document.createElement('div'); tarjeta.className = 'lis lis-tour-tarjeta'; tarjeta.setAttribute('role', 'dialog'); tarjeta.setAttribute('aria-label', 'Guía rápida');
    document.body.appendChild(anillo); document.body.appendChild(tarjeta);
    function fin() {
      try { localStorage.setItem('lis-tour-' + clave, '1'); } catch (e) {}
      anillo.remove(); tarjeta.remove();
      lisScroll.off(coloca); window.removeEventListener('resize', coloca); document.removeEventListener('keydown', teclas);
    }
    function coloca() {
      if (!objetivo) return;
      var r = objetivo.getBoundingClientRect(), m = 8, sx = lisScroll.x(), sy = lisScroll.y();
      anillo.style.top = (r.top + sy - m) + 'px'; anillo.style.left = (r.left + sx - m) + 'px';
      anillo.style.width = (r.width + 2 * m) + 'px'; anillo.style.height = (r.height + 2 * m) + 'px';
      if (movil()) { tarjeta.style.top = ''; tarjeta.style.left = ''; return; }
      var th = tarjeta.offsetHeight, tw = tarjeta.offsetWidth, top;
      var left;
      if (r.height > window.innerHeight * .45 && r.right + 14 + tw < window.innerWidth - 12) {
        // Objetivo muy alto (una columna entera): la tarjeta va a su derecha, arriba
        tarjeta.style.top = (sy + Math.max(90, r.top + 8)) + 'px'; tarjeta.style.left = (sx + r.right + 14) + 'px'; return;
      }
      if (r.bottom + 14 + th < window.innerHeight - 10) top = r.bottom + sy + 14;
      else if (r.top - 14 - th > 80) top = r.top + sy - 14 - th;
      else top = sy + Math.max(80, Math.min(r.top, window.innerHeight - th - 10));
      left = Math.max(sx + 12, Math.min(r.left + sx, sx + window.innerWidth - tw - 12));
      tarjeta.style.top = top + 'px'; tarjeta.style.left = left + 'px';
    }
    function muestra(n) {
      i = n; var p = pasos[i]; objetivo = document.querySelector(p.sel);
      var ultimo = i === pasos.length - 1;
      tarjeta.innerHTML = '<p class="eyebrow">' + (i + 1) + ' de ' + pasos.length + '</p><h4>' + p.titulo + '</h4><p>' + p.texto + '</p>' +
        '<div class="pie">' + (ultimo ? '<span></span>' : '<button type="button" class="saltar">Saltar la guía</button>') +
        '<button type="button" class="btn btn-rojo sig">' + (ultimo ? 'Entendido' : 'Siguiente') + '</button></div>';
      tarjeta.querySelector('.sig').addEventListener('click', function () { ultimo ? fin() : muestra(i + 1); });
      var sal = tarjeta.querySelector('.saltar'); if (sal) sal.addEventListener('click', fin);
      var r = objetivo.getBoundingClientRect(), alto = window.innerHeight;
      var destino = lisScroll.y() + r.top - (movil() ? 84 : Math.max(90, (alto - r.height) / 2));
      lisScroll.to(Math.max(0, destino), 'smooth');
      coloca(); setTimeout(coloca, 250); setTimeout(coloca, 600); setTimeout(coloca, 1000);
    }
    function teclas(e) { if (e.key === 'Escape') fin(); }
    lisScroll.on(coloca); window.addEventListener('resize', coloca); document.addEventListener('keydown', teclas);
    muestra(0);
  }
  window.lisTourIniciar = iniciar;
  if (def) {
    var clave = def.getAttribute('data-clave') || 'tour', pasos = null;
    try { pasos = JSON.parse(def.textContent); } catch (e) {}
    if (pasos) {
      var visto = false; try { visto = localStorage.getItem('lis-tour-' + clave) === '1'; } catch (e) {}
      if (!visto) setTimeout(function () { iniciar(clave, pasos); }, 900);
      document.querySelectorAll('[data-tour-ver]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); iniciar(clave, pasos); }); });
    }
  }
})();
